import React from 'react';
import { Field } from 'formik';
import TextareaAutosize from 'react-textarea-autosize';
import { Textarea as ShadTextarea } from '@dashboard/components/ui/textarea';
import { cn } from '@dashboard/lib/utils';
import ClearFieldButton from '../ClearFieldButton';

// Mirrors the shadcn Textarea base classes so autosized textareas look identical.
const SHADCN_TEXTAREA_CLASSES =
  'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex w-full rounded-md border bg-transparent px-3 py-2 text-sm shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50';

// Field only turns innerRef into a ref for a string `as`; a component gets it as a plain prop.
const AutosizeTextareaImpl = ({ className, innerRef, ...props }) => (
  <TextareaAutosize
    ref={innerRef}
    data-slot="textarea"
    className={cn(SHADCN_TEXTAREA_CLASSES, className)}
    {...props}
  />
);

const PlainTextarea = ({ innerRef, ...props }) => <ShadTextarea ref={innerRef} {...props} />;

const Textarea = ({ disabled, className, inputClassName, autosize, clearable, ...props }) => {
  const node = React.useRef();
  const Component = autosize ? AutosizeTextareaImpl : PlainTextarea;
  const textarea = (
    <Field
      innerRef={node}
      {...props}
      as={Component}
      className={cn(className, inputClassName, clearable && 'pr-9')}
      disabled={disabled}
    />
  );

  if (!clearable) return textarea;

  return (
    <div className="group/clear relative">
      {textarea}
      {/* Top corner: the bottom one belongs to the resize handle. */}
      <ClearFieldButton
        name={props.name}
        disabled={disabled}
        onClear={() => node.current?.focus()}
        className="top-1.5"
      />
    </div>
  );
};

export default Textarea;
